module.exports = __webpack_public_path__ + "Tinebase/js/ace-haskell_cabal-FAT.js";